<section [formGroup]="stepForm">
  <mbs-form-group>
    <div *ngIf="isRestoreHyperV"
         class="mb-1"
         [attr.data-test-element]="elementsSelector.name.restoreHyperV">
      <mbs-radio formControlName="restoreAs"
                 name="restoreAsRadio"
                 [label]="'wizards:hyperVMachineImport' | i18next"
                 (change)="changeRestoreAsHandler($event)"
                 [descriptionClasses]="'mt-1'"
                 [descriptionOutside]="false"
                 [disabledSelf]="disableRestoreAsNotVirtual"
                 [id]="'restore-as-radio-4'"
                 [value]="restoreAsDiskEnum.RestoreToHyperVAndImport">
        <ng-template radioDescription>
          <div class="text-sm"
               [class.text-muted]="disableRestoreAsNotVirtual">
            {{'wizards:hyperVSubtitleImport' | i18next}}
          </div>
        </ng-template>
      </mbs-radio>

      <mbs-radio formControlName="restoreAs"
                 name="restoreAsRadio"
                 [label]="'wizards:hyperVMachine' | i18next"
                 (change)="changeRestoreAsHandler($event)"
                 [descriptionClasses]="'mt-1'"
                 [descriptionOutside]="false"
                 [disabledSelf]="disableRestoreAsNotVirtual"
                 [id]="'restore-as-radio-2'"
                 [value]="restoreAsDiskEnum.RestoreToHyperV">
        <ng-template radioDescription>
          <div class="text-sm"
               [class.text-muted]="disableRestoreAsNotVirtual">
            {{'wizards:hyperVSubtitle' | i18next}}
          </div>
        </ng-template>
      </mbs-radio>
    </div>

    <mbs-radio *ngIf="isRestoreVMWare"
               formControlName="restoreAs"
               name="restoreAsRadio"
               (change)="changeRestoreAsHandler($event)"
               [attr.data-test-element]="elementsSelector.name.restoreVMWare"
               [label]="'wizards:vmWareVSphere' | i18next"
               [descriptionClasses]="'mt-1'"
               [descriptionOutside]="false"
               [disabledSelf]="disableRestoreAsNotVirtual"
               [id]="'restore-as-radio-3'"
               [value]="restoreAsDiskEnum.RestoreToVMware">
      <ng-template radioDescription>
        <span class="text-sm mb-2"
              [class.text-muted]="disableRestoreAsNotVirtual">
          {{'wizards:vmWareVSphereSubtitle' | i18next}}
        </span>
      </ng-template>
    </mbs-radio>

    <mbs-radio *ngIf="!isVMRestore"
               formControlName="restoreAs"
               name="restoreAsRadio"
               (change)="changeRestoreAsHandler($event)"
               [attr.data-test-element]="elementsSelector.name.notVMRestore"
               [descriptionClasses]="'mt-1'"
               [descriptionOutside]="false"
               [id]="'restore-as-disk-radio-0'"
               [label]="'wizards:physical_disk_label' | i18next"
               [value]="restoreAsDiskEnum.Physical">
      <ng-template radioDescription>
        <span class="text-sm">{{'wizards:physical_disk_subtitle' | i18next}}</span>
      </ng-template>
    </mbs-radio>

    <mbs-radio formControlName="restoreAs"
               name="restoreAsRadio"
               [disabledSelf]="(isVMRestore && selectedComputersCount) > 1 || disableRestoreAsVirtual"
               [label]="'wizards:virtual_disk_label' | i18next"
               (change)="changeRestoreAsHandler($event)"
               [descriptionClasses]="'mt-1'"
               [descriptionOutside]="false"
               [id]="'restore-as-radio-1'"
               [value]="restoreAsDiskEnum.Virtual">
      <ng-template radioDescription>
        <div class="text-sm mb-2">{{(isRestoreHyperV ? 'wizards:virtualDiskHVSubtitle' : isRestoreVMWare ? 'wizards:virtualDiskWMSubtitle' : 'wizards:virtual_disk_subtitle') | i18next}}</div>
        <mbs-select formControlName="selectedFileFormat"
                    class="mt-3"
                    [clearable]="false"
                    [disabledSelf]="(isVMRestore && selectedComputersCount > 1) || disableRestoreAsVirtual"
                    [id]="'file-format-select'"
                    [items]="fileFormats"
                    [label]="'wizards:virtual_format_label' | i18next"></mbs-select>
      </ng-template>
    </mbs-radio>
  </mbs-form-group>

  <mbs-alert *ngIf="isVMRestore && selectedComputersCount > 1"
             class="mb-0 mt-3"
             [attr.data-test-element]="elementsSelector.name.multipleMachineAlert"
             [type]="mbsPopupType.warning"
             [icon]="true">
    {{'wizards:multipleMachineAlert' | i18next}}
  </mbs-alert>
</section>
